import React, { useState, useEffect } from 'react';
import Header from './gapsy-header';
import Navigation from './gapsy-Anavigation';
import Footer from './gapsy-footer';
import "bootstrap/dist/css/bootstrap.min.css"
import 'bootstrap-icons/font/bootstrap-icons.css';
import styles from '../assets/css/gapsy-dashboard.module.css';
import tabStyles from '../assets/css/gapsy-tabs.module.css';
import { createTextFileApi, mappingdata, RoleandMapping, shariahconfig, getshariahconfig, OwnershipApi, ListAlldept, Getlocations } from "../components/ApiProperty";
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import formStyles from '../assets/css/gapsy-form.module.css';
import { BiSortUp, BiSortDown, BiSort } from "react-icons/bi";
import tableStyles from '../assets/css/sharedTableStyles.module.css';
import { tableCellStyle2, UsersPagination } from "../components/TableProperty";
import { Modal, Button } from 'react-bootstrap';
import { SearchBox, UploadLoadingIcon } from "../components/Propertyfile";
import GapsyShariahModify from './gapsyShariahModify';

const GapsyComplaintsConfiguration = () => {
    const [activeTab, setActiveTab] = useState('ldap'); // 'manual' or 'ai'
    const [users, setUsers] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [filteredUsers, setFilteredUsers] = useState([]);
    const usersItemsPerPage = 7; // Set the number of items per page
    const navigate = useNavigate();
    const [userPerPage, setUsersPerPage] = useState(1); // Set the initial page to 1
    const [showModalLdap, setShowModalLdap] = useState(false);
    const [editIndex, setEditIndex] = useState(null);
    const [checkerData, setCheckerData] = useState(null);
    const [message, setMessage] = useState("");
    const [modalMessage, setModalMessage] = useState('');
    const [messageType, setMessageType] = useState(''); // 'success', 'warning', or 'error'
    const [selectedDepartments, setSelectedDepartments] = useState([]);
    const [modalMessage3, setModalMessage3] = useState('');
    const [pendingPayload, setPendingPayload] = useState(null); // store request for retry

    const [selectedOption, setSelectedOption] = useState('All');
    const [disableInputs, setDisableInputs] = useState(false);
    const [passwordGenerated, setPasswordGenerated] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [selectedLocationValues, setSelectedLocationValues] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [showAllowUploadPopup, setShowAllowUploadPopup] = useState(false);
    const [showNoRecordsModal, setShowNoRecordsModal] = useState(false);
    const [mode, setMode] = useState("");
    const [departments, setDepartments] = useState([]); // Initialize as empty array
    const [formData, setFormData] = useState({
        adminId: '',
        userId: '',
        userName: '',
        userRole: '',
        departments: '',
        departmentname: '',
        userRole: '',
        orgHierarchy: '',
        userLocation: '',
        active_yn: '',
        mappedId: '',
        searchUserId: '' // Add this line
    });
    const [initialData, setInitialData] = useState({});
    const [selectedRole, setSelectedRole] = useState('');
    const [hierarchy, setHierarchy] = useState('');
    const [sortConfig, setSortConfig] = useState({ key: 'userId', direction: 'asc' });
    const [error, setError] = useState("");
    const [selectedStatus, setSelectedStatus] = useState('');
    const [selectedChecker, setSelectedChecker] = useState('');
    const [permissions, setPermissions] = useState({
        viewMaker: false,
        downloadMaker: false,
        viewChecker: false,
        downloadChecker: false,
        viewRiskOfficer: false,
        downloadRiskOfficer: false,
    });
    const [selectedTemplate, setSelectedTemplate] = useState("");

    let csrfToken = sessionStorage.getItem("tokenizedSession");



    const dept = sessionStorage.getItem("dept");

    const roles = [
        "Shariah Risk"
    ];

    useEffect(() => {
        fetchUsers();
    }, []);

    // const fetchUsers = async () => {
    //     try {

    //         const config = {
    //             headers: {
    //                 userId: localStorage.getItem("userid"),
    //                 "x-csrf-token": csrfToken,
    //             },
    //             withCredentials: true,
    //             params: {
    //                 userId: localStorage.getItem("userid"),
    //                 // templateName: "Risk_shariah_pillar1",
    //                 templateName: "Shariah Risk",
    //             },
    //         };

    //         const response = await axios.post(getshariahconfig, {}, config);

    //         const apiData = [{
    //             templateName: response.data.templateName,
    //             permissions: response.data.data,
    //         }];

    //         setSelectedTemplate(response.data.templateName);
    //         setUsers(apiData);
    //         setFilteredUsers(apiData);

    //     } catch (error) {
    //         console.error(error);
    //     } finally {
    //         setIsLoading(false);
    //     }
    // };


    const fetchUsers = async () => {
        setIsLoading(true);

        try {
            const adminId = localStorage.getItem("userid");

            const config = {
                headers: {
                    userId: adminId,
                    "x-csrf-token": csrfToken,
                },
                withCredentials: true,
            };

            const templates = [
                {
                    displayName: "Shariah Risk",
                    fetchTemplateName: "Shariah Risk",
                    apiTemplateName: "Risk_shariah_pillar1",
                },
                {
                    displayName: "Customer Complaints",
                    fetchTemplateName: "Customer Complaints",
                    apiTemplateName: "Risk_customer_complaints",
                },
                {
                    displayName: "Media Publicity",
                    fetchTemplateName: "Media Publicity",
                    apiTemplateName: "Risk_media_publicity",
                },
                {
                    displayName: "Operational Thresholds",
                    fetchTemplateName: "Operational Thresholds",
                    apiTemplateName: "Risk_operational_thresholds",
                },
                {
                    displayName: "Leadership Thresholds",
                    fetchTemplateName: "Leadership Thresholds",
                    apiTemplateName: "Risk_leadership_thresholds",
                },
            ];

            const responses = await Promise.all(
                templates.map((template) =>
                    axios.post(
                        getshariahconfig,
                        {},
                        {
                            ...config,
                            params: {
                                userId: adminId,
                                templateName: template.fetchTemplateName,
                            },
                        }
                    )
                )
            );

            const apiData = responses.map((response, index) => ({
                ...templates[index],
                templateName: templates[index].displayName,
                permissions: Array.isArray(response.data?.data)
                    ? response.data.data
                    : [],
            }));

            setUsers(apiData);
            setFilteredUsers(apiData);

        } catch (error) {
            console.error("Error fetching configurations:", error);
            setUsers([]);
            setFilteredUsers([]);
        } finally {
            setIsLoading(false);
        }
    };


    const fetchOwnership = async () => {
        try {
            // setIsLoading(true);
            const config = {
                params: { "adminId": localStorage.getItem('userid'), ownership: "Y" },
                headers: {
                    'x-csrf-token': csrfToken,
                },
                withCredentials: true
            }
            const response = await axios.post(OwnershipApi, {}, config);
            console.log("Ownership API Response:", response.data);

            // Extract Ownership array
            const ownershipList = response.data?.Ownership || [];
            console.log("Fetched Ownership List:", ownershipList);

            setDepartments(ownershipList);

        } catch (error) {
            console.error("Error fetching departments:", error);
            setDepartments([]);
        }
    };

    useEffect(() => {
        fetchOwnership();
    }, []);

    const handleCancelUpload = () => {
        setShowAllowUploadPopup(false);
        setPendingPayload(null);
    };


    const handleForceUpload = async () => {
        try {
            setShowAllowUploadPopup(false);
            // setIsLoading(true);

            const responseDb = await submitLdapData('Y'); // second call

            if (responseDb.data?.status === 'success') {
                setMessageType('success');
                setModalMessage(responseDb.data?.message);
            } else {
                setMessageType('error');
                setModalMessage(responseDb.data?.message || "Update failed");
            }

        } catch (error) {
            console.error(error);
            setMessageType('error');
            setModalMessage('Error while updating');
        } finally {
            setIsLoading(false);
            setPendingPayload(null);
        }
    };


    const submitLdapData = async (allowUpdate = "") => {
        const adminId = localStorage.getItem("userid") || "";

        const templateConfigs = {
            "Shariah Risk": {
                apiTemplateName: "Risk_shariah_pillar1",
                filePrefix: "shariah",
            },
            "Customer Complaints": {
                apiTemplateName: "Risk_customer_complaints",
                filePrefix: "shariah",
            },
            "Media Publicity": {
                apiTemplateName: "Risk_media_publicity",
                filePrefix: "shariah",
            },
            "Operational Thresholds": {
                apiTemplateName: "Risk_operational_thresholds",
                filePrefix: "shariah",
            },
            "Leadership Thresholds": {
                apiTemplateName: "Risk_leadership_thresholds",
                filePrefix: "shariah",
            },
            "Compliance": {
                apiTemplateName: "Risk_compliance",
                filePrefix: "shariah",
            },
        };

        const templateConfig = templateConfigs[selectedTemplate];

        if (!templateConfig) {
            throw new Error("Invalid template selected.");
        }

        const jsonData = {
            template: selectedTemplate,
            adminId,
            permissions: [
                {
                    userId: "10192",
                    userRole: "maker",
                    download: permissions.downloadMaker ? "Y" : "N",
                },
                {
                    userId: "10007",
                    userRole: "checker",
                    download: permissions.downloadChecker ? "Y" : "N",
                },
                {
                    userId: "10159",
                    userRole: "riskOfficer",
                    download: permissions.downloadRiskOfficer ? "Y" : "N",
                },
            ],
        };

        const content = JSON.stringify(jsonData, null, 2);
        const filename = `${adminId}_${templateConfig.filePrefix}_config.json`;

        // Step 1: Save the selected template's JSON configuration.
        await axios.post(
            createTextFileApi,
            { filename, content },
            {
                headers: {
                    "Content-Type": "application/json",
                    userId: adminId,
                    "x-csrf-token": csrfToken,
                },
                withCredentials: true,
            }
        );

        // Step 2: Map the selected template.
        const config = {
            headers: {
                adminId,
                "x-csrf-token": csrfToken,
            },
            withCredentials: true,
            params: {
                filePath: `/saswork/nas/${filename}`,
                Notifications: "IN",
                templateName: templateConfig.apiTemplateName,
                dept,
                allowUpdate,
            },
        };

        return await axios.post(shariahconfig, {}, config);
    };


    const handleLdapSubmit = async (e) => {
        e.preventDefault();

        try {
            // Template validation
            if (!selectedTemplate) {
                setMessageType("error");
                setModalMessage("Please select a template.");
                return;
            }

            // At least one permission should be selected
            const hasPermission =
                // permissions.viewMaker ||
                permissions.downloadMaker ||
                // permissions.viewChecker ||
                permissions.downloadChecker ||
                // permissions.viewRiskOfficer ||
                permissions.downloadRiskOfficer;

            if (!hasPermission) {
                setMessageType("error");
                setModalMessage("Please select at least one permission.");
                return;
            }

            setIsLoading(true);

            const responseDb = await submitLdapData();

            if (responseDb.data?.status?.toLowerCase() === "update") {
                setPendingPayload(true);

                setModalMessage3(`
                Configuration already exists.<br/>
                  Do you want to update?
              `);

                setShowAllowUploadPopup(true);
                return;
            }

            if (responseDb.data?.status?.toLowerCase() === "success") {
                setMessageType("success");
                setModalMessage("Configuration Saved Successfully");
            } else {
                setMessageType("error");
                setModalMessage(responseDb.data?.message || "Failed");
            }
        } catch (error) {
            console.error(error);
            setMessageType("error");
            setModalMessage("Error while processing request.");
        } finally {
            setIsLoading(false);
        }
    };


    // const handleCloseLdap = () => {

    //     if (messageType === 'error') {
    //         setModalMessage('');
    //         return;
    //     }
    //     setShowModalLdap(false);

    //     setFormData({
    //         searchUserId: "",
    //         userFirstName: "",
    //         userRole: "",
    //         orgHierarchy: ""
    //     });

    //     setModalMessage('');
    //     setSelectedRole("");           //  FIX
    //     setSelectedDepartments([]);    //  FIX

    //     setInitialData({});
    //     setEditIndex(null);
    //     setMessage('');
    // };
    const handleCloseModal = () => {
        setModalMessage('');
        setMessageType('');
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };


    const handleRoleChange = (e) => {
        const newRole = e.target.value;

        // Clear mappedId if changing from Checker to Maker
        if (selectedRole === 'Checker' && newRole === 'Maker') {
            localStorage.removeItem('mappedId');
        }

        setFormData({
            ...formData,
            userRole: newRole,
        });
        setSelectedRole(newRole);
    };

    // const handleCloseLdap = () => {
    //     setModalMessage('');
    //     setModalMessage3('');
    //     setShowModalLdap(false);
    //     // setFormData({ userName: '', userId: '', userRole: '', departmentname: '', departments: '', userPassword: '', userRole: '', orgHierarchy: '', userLocation: '', active_yn: '', mappedId: '' });
    //     setInitialData({});
    //     setEditIndex(null);
    //     setMessage('');
    // };

    const handleCloseLdap = () => {
        setModalMessage('');
        setModalMessage3('');
        setShowModalLdap(false);

        setInitialData({});
        setEditIndex(null);
        setMessage('');

        // ✅ REFRESH TABLE
        fetchUsers();
    };

    const handleFocus = (e) => {
        const { name } = e.target;
        if (!validateField(name)) {
            e.preventDefault();
        }
    };
    // const handleHierarchyChange = async (hierarchyValue) => {
    //     // Update form state
    //     setFormData((prevFormData) => ({
    //         ...prevFormData,
    //         orgHierarchy: hierarchyValue,
    //     }));

    //     // Update hierarchy state
    //     setHierarchy(hierarchyValue);

    //     try {
    //         // 1. First API call - Fetch locations
    //         const locationResponse = await fetch(Getlocations, {
    //             method: 'POST',
    //             headers: {
    //                 'x-csrf-token': csrfToken // if needed
    //             },
    //         });
    //         if (!locationResponse.ok) {
    //             throw new Error('Failed to fetch location data');
    //         }

    //         const locationData = await locationResponse.json();
    //         // setSelectedLocationValues(locationData.location || []);
    //         setSelectedLocationValues(Array.isArray(locationData.location) ? locationData.location : []);

    //         // 2. Second API call - Fetch list of checkers (only if hierarchyValue means which we selected in dropdown)
    //         if (hierarchyValue) {
    //             const config = {
    //                 params: {
    //                     "adminId": localStorage.getItem('userid'),
    //                     "dept": hierarchyValue
    //                 },
    //                 headers: {
    //                     'x-csrf-token': csrfToken,
    //                 },
    //                 withCredentials: true
    //             };
    //             const checkersResponse = await axios.post(List_Checker, {}, config);
    //             setCheckerData(checkersResponse.data.checkers_list);

    //         }
    //     } catch (error) {
    //         console.error('Error in handleHierarchyChange:', error.message);
    //         setSelectedLocationValues([]);
    //         setCheckerData([]); // Reset checkers data on error
    //     }
    // };

    const handleCheckers = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
        setSelectedChecker(e.target.value);
    };

    const handleUserStatus = (e) => {
        setFormData({
            ...formData,
            active_yn: e.target.value,
        });
        setSelectedStatus(e.target.value);
    };

    const validateField = (fieldName) => {
        if (fieldName === 'userFirstName' && !formData.userId) {
            setError('User Id is required');
            return false;
        }
        if (fieldName === 'userEmail' && !formData.userId) {
            setError('User Name is required');
            return false;
        }
        if (fieldName === 'userPassword' && !formData.userId) {
            setError('User Password is required');
            return false;
        }
        // Clear error message if validation passes
        setError(null);
        return true;
    };

    const handleDashboard = (e) => {
        e.preventDefault();
        navigate('/gapsyAdashboard');
        // Additional logic if needed
    };

    const handleAddRow = (e) => {
        e.preventDefault();
        navigate('/GapsyComplaintsConfig');
        // Additional logic if needed
    };

    const validateEmail = (inputEmail) => {
        // Regular expression for basic email format validation
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(inputEmail);
    };

    const getSortedAndFilteredUsers = () => {
        if (!Array.isArray(filteredUsers)) return [];  // ✅ safety

        return [...filteredUsers].sort((a, b) => {
            if (a.newlyCreated && !b.newlyCreated) return -1;
            if (!a.newlyCreated && b.newlyCreated) return 1;

            const aValue = typeof a[sortConfig.key] === 'string'
                ? a[sortConfig.key].toLowerCase()
                : a[sortConfig.key];

            const bValue = typeof b[sortConfig.key] === 'string'
                ? b[sortConfig.key].toLowerCase()
                : b[sortConfig.key];

            if (aValue < bValue) return sortConfig.direction === 'asc' ? -1 : 1;
            if (aValue > bValue) return sortConfig.direction === 'asc' ? 1 : -1;

            return 0;
        });
    };

    const sortedAndFilteredUsers = getSortedAndFilteredUsers();


    const handleReset = () => {

        const permissionsData = initialData?.permissions || [];

        const maker = permissionsData.find(
            p => p.userRole.toLowerCase() === "maker"
        );

        const checker = permissionsData.find(
            p => p.userRole.toLowerCase() === "checker"
        );

        const riskOfficer = permissionsData.find(
            p => p.userRole.toLowerCase() === "riskofficer"
        );

        setSelectedRole(initialData?.templateName || "");

        setPermissions({
            downloadMaker: maker?.download === "Y",
            downloadChecker: checker?.download === "Y",
            downloadRiskOfficer: riskOfficer?.download === "Y",
        });
    };


    const handleEdit = (data) => {
        setInitialData(data);

        setSelectedTemplate(data.templateName);
        setSelectedRole(data.templateName);
        setMode("edit");

        const permissionsData = data.permissions || [];

        const maker = permissionsData.find(
            p => p.userRole?.toLowerCase() === "maker"
        );

        const checker = permissionsData.find(
            p => p.userRole?.toLowerCase() === "checker"
        );

        const riskOfficer = permissionsData.find(
            p => p.userRole?.toLowerCase() === "riskofficer"
        );

        setPermissions({
            viewMaker: false,
            downloadMaker: maker?.download === "Y",
            viewChecker: false,
            downloadChecker: checker?.download === "Y",
            viewRiskOfficer: false,
            downloadRiskOfficer: riskOfficer?.download === "Y",
        });
    };


    const requestSort = (key) => {
        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }
        setSortConfig({ key, direction });
    };

    const getSortIcon = (key) => {
        if (sortConfig.key !== key) {
            return <BiSort />;  // Neutral/no sort icon
        }
        return sortConfig.direction === 'ascending'
            ? <BiSortUp />
            : <BiSortDown />;
    };

    const renderUsersTable = () => {
        const startIndex = (userPerPage - 1) * usersItemsPerPage;

        return sortedAndFilteredUsers
            .slice(startIndex, startIndex + usersItemsPerPage)
            .map((data, index) => {

                const permissions = data.permissions || [];

                const maker = permissions.find(x => x.userRole === "maker");
                const checker = permissions.find(x => x.userRole === "checker");
                const riskOfficer = permissions.find(x => x.userRole === "riskOfficer");

                return (
                    <tr key={index}>
                        <td>
                            <i
                                className="bi bi-pencil"
                                style={{ cursor: "pointer" }}
                                onClick={() => handleEdit(data)}
                            />
                        </td>

                        <td>{data.templateName}</td>

                        <td className="p-0">

                            <div className="py-2">
                                {/* Download: {maker?.download === "Y" ? "Yes" : "No"} */}
                                View History: <span className="fw-bold">{maker?.download === "Y" ? "Yes" : "No"}</span>
                            </div>
                        </td>

                        <td className="p-0">

                            <div className="py-2">
                                {/* Download: {checker?.download === "Y" ? "Yes" : "No"} */}
                                View History: <span className="fw-bold">{checker?.download === "Y" ? "Yes" : "No"}</span>
                            </div>
                        </td>

                        <td className="p-0">

                            <div className="py-2">
                                {/* Download: {riskOfficer?.download === "Y" ? "Yes" : "No"} */}
                                View History: <span className="fw-bold">{riskOfficer?.download === "Y" ? "Yes" : "No"}</span>
                            </div>
                        </td>
                    </tr>
                );
            });
    };

    const handleSearch = (event) => {
        const query = event.target.value.toLowerCase();
        setSearchQuery(query);

        const filtered = users.filter(user => {
            const userId = user.userId?.toString().toLowerCase() || "";
            const userName = user.userName?.toLowerCase() || "";
            const userRole = user.userRole?.toLowerCase() || "";
            const department = user.departmentname?.toLowerCase() || "";

            return (
                userId.includes(query) ||
                userName.includes(query) ||
                userRole.includes(query) ||
                department.includes(query)   // IMPORTANT FIX
            );
        });

        if (filtered.length === 0) {
            setShowNoRecordsModal(true);
            setSearchQuery('');
            setFilteredUsers(users);
        } else {
            setFilteredUsers(filtered);
        }

        setUsersPerPage(1);
    };

    return (
        <div className={`d-flex flex-column min-vh-100 ${styles.pageFullBackground}`}>
            <Header />
            <Navigation />
            <div className="top-0 px-4 py-2 text-white">
                <div className="d-flex justify-content-between align-items-center flex-wrap">
                    <div>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb mb-1">
                                <li className="breadcrumb-item">
                                    <a onClick={handleDashboard} className={`text-info ${styles.textInfo}`} style={{ textDecoration: 'none' }}>
                                        <i className="bi bi-house me-2" style={{ cursor: "pointer" }}></i>/
                                    </a>
                                </li>
                                <li className={`breadcrumb-item active ${styles.breadcrumbItem}`} aria-current="page">
                                    <i className="bi bi-person-plus me-2"></i>View History
                                </li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
            <main className="flex-grow-1 container-fluid">
                <div className={styles.mainContainer}>
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-lg-6 col-md-12 mx-auto">
                                <div className={`card h-100 ${styles.cardBorder} ${styles.card}`}>
                                    <div className="card-body">

                                        {/* Header + Search Row with single underline */}
                                        <div className={`d-flex justify-content-between align-items-center pb-2 mb-2 ${styles.borderBottom}`}>

                                            {/* Left: Heading */}
                                            <h6 className="mb-0">View History</h6>

                                            {/* Right: Search Box */}
                                            <div className="d-flex flex-wrap gap-3">
                                                <button
                                                    className="btn btn-sm btn-outline-primary"
                                                    onClick={handleAddRow}
                                                    title="Add New Configuration"
                                                >
                                                    <i className="bi bi-plus" style={{ fontSize: '14px' }}></i>
                                                </button>
                                                <SearchBox searchTerm={searchQuery} handleSearch={handleSearch} />
                                            </div>
                                        </div>

                                        <div className="table-on-homepage-only mb-3">
                                            <div className={`tableWrapper ${tableStyles.tableWrapper}`}>
                                                <table className={`table table-bordered table-hover text-center customScrollTable ${tableStyles.customScrollTable}`}>
                                                    <thead className="sticky-header">
                                                        {selectedOption !== 'All' && (
                                                            <tr className="rowFilter">
                                                                <td colSpan="6">Applied Filter : {selectedOption}</td>
                                                            </tr>
                                                        )}
                                                        <tr>
                                                            <th>Modify</th>
                                                            <th onClick={() => requestSort('userId')}>
                                                                Template Name
                                                                <span style={{ textAlign: 'center', padding: '5px' }}>
                                                                    {getSortIcon('userId')}
                                                                </span>
                                                            </th>

                                                            <th onClick={() => requestSort('userFirstName')}>
                                                                Maker
                                                            </th>
                                                            <th>Checker</th>
                                                            <th>Risk Officer</th>

                                                        </tr>
                                                    </thead>
                                                    <tbody>{renderUsersTable()}</tbody>
                                                </table>
                                            </div>
                                        </div>
                                        {/* )} */}


                                        {/* Pagination */}
                                        <div className="d-flex justify-content-end">
                                            <UsersPagination
                                                currentPage={userPerPage}
                                                itemsPerPage={usersItemsPerPage}
                                                totalItems={sortedAndFilteredUsers.length}
                                                onPageChange={setUsersPerPage}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-12">
                                <div className={`card h-100 ${styles.cardBorder} ${styles.card}`}>
                                    <div className="card-body">
                                        <div className="">
                                            <h6 className={`pb-1 mb-2 ${styles.borderBottom}`}>Modify Configuration</h6>
                                            <div className={`mx-auto ${formStyles.formWrapper}`}>
                                                {mode === "edit" ? (
                                                    <form className="form px-3" onSubmit={handleLdapSubmit}>

                                                        <input
                                                            type="hidden"
                                                            name="adminId"
                                                            value={localStorage.getItem("userid")}
                                                            readOnly
                                                        />

                                                        {/* Template */}
                                                        <div className="form-group row mb-3">
                                                            <label className="col-sm-4 col-form-label label-black">
                                                                Template Name
                                                            </label>

                                                            <div className="col-sm-7">
                                                                <input
                                                                    type="text"
                                                                    className="form-control form-control-sm"
                                                                    value={selectedTemplate}
                                                                    readOnly
                                                                />
                                                            </div>
                                                        </div>

                                                        {/* Permissions */}
                                                        <div className="form-group row mb-3">
                                                            <label className="col-sm-4 col-form-label label-black">
                                                                Permissions
                                                            </label>

                                                            <div className="col-sm-7">
                                                                <div className="table-on-homepage-only mb-3">
                                                                    <div className={`tableWrapper ${tableStyles.tableWrapper}`}>
                                                                        <table className={`table table-bordered table-hover text-center customScrollTable ${tableStyles.customScrollTable}`}>
                                                                            <thead className="sticky-header">
                                                                                <tr>
                                                                                    <th>User ID</th>
                                                                                    <th>User Role</th>
                                                                                    {/* <th>View</th> */}
                                                                                    <th>View History</th>
                                                                                </tr>
                                                                            </thead>

                                                                            <tbody>
                                                                                <tr>
                                                                                    <td className="text-start">10192</td>
                                                                                    <td className="text-start">
                                                                                        {selectedTemplate === "Customer Complaints"
                                                                                            ? "Pillar 2 Risk Maker" 
                                                                                            : "Pillar 2 Risk Maker"}
                                                                                    </td>

                                                                                    {/* <td>
                                                                                        <input
                                                                                            type="checkbox"
                                                                                            checked={permissions.viewMaker}
                                                                                            onChange={(e) =>
                                                                                                setPermissions({
                                                                                                    ...permissions,
                                                                                                    viewMaker: e.target.checked,
                                                                                                })
                                                                                            }
                                                                                        />
                                                                                    </td> */}

                                                                                    <td>
                                                                                        <input
                                                                                            type="checkbox"
                                                                                            checked={permissions.downloadMaker}
                                                                                            onChange={(e) =>
                                                                                                setPermissions({
                                                                                                    ...permissions,
                                                                                                    downloadMaker: e.target.checked,
                                                                                                })
                                                                                            }
                                                                                        />
                                                                                    </td>
                                                                                </tr>

                                                                                <tr>
                                                                                    <td className="text-start">10007</td>
                                                                                    {/* <td className="text-start">Pillar 2 Risk Checker</td> */}
                                                                                    <td className="text-start">
                                                                                        {selectedTemplate === "Customer Complaints"
                                                                                            ? "Pillar 2 Risk Checker"
                                                                                            : "Pillar 2 Risk Checker"}
                                                                                    </td>

                                                                                    {/* <td>
                                                                                        <input
                                                                                            type="checkbox"
                                                                                            checked={permissions.viewChecker}
                                                                                            onChange={(e) =>
                                                                                                setPermissions({
                                                                                                    ...permissions,
                                                                                                    viewChecker: e.target.checked,
                                                                                                })
                                                                                            }
                                                                                        />
                                                                                    </td> */}

                                                                                    <td>
                                                                                        <input
                                                                                            type="checkbox"
                                                                                            checked={permissions.downloadChecker}
                                                                                            onChange={(e) =>
                                                                                                setPermissions({
                                                                                                    ...permissions,
                                                                                                    downloadChecker: e.target.checked,
                                                                                                })
                                                                                            }
                                                                                        />
                                                                                    </td>
                                                                                </tr>

                                                                                <tr>
                                                                                    <td className="text-start">10159</td>
                                                                                    <td className="text-start">Risk Officer</td>

                                                                                    {/* <td>
                                                                                        <input
                                                                                            type="checkbox"
                                                                                            checked={permissions.viewRiskOfficer}
                                                                                            onChange={(e) =>
                                                                                                setPermissions({
                                                                                                    ...permissions,
                                                                                                    viewRiskOfficer: e.target.checked,
                                                                                                })
                                                                                            }
                                                                                        />
                                                                                    </td> */}

                                                                                    <td>
                                                                                        <input
                                                                                            type="checkbox"
                                                                                            checked={permissions.downloadRiskOfficer}
                                                                                            onChange={(e) =>
                                                                                                setPermissions({
                                                                                                    ...permissions,
                                                                                                    downloadRiskOfficer: e.target.checked,
                                                                                                })
                                                                                            }
                                                                                        />
                                                                                    </td>
                                                                                </tr>
                                                                            </tbody>
                                                                        </table>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* Buttons */}
                                                        <div className="form-group row">
                                                            <div className="col-sm-4"></div>

                                                            <div className="col-sm-7 d-flex">
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-secondary btn-sm me-2"
                                                                    onClick={handleReset}
                                                                >
                                                                    Reset
                                                                </button>

                                                                <button
                                                                    type="submit"
                                                                    className="btn btn-primary btn-sm"
                                                                >
                                                                    Save
                                                                </button>
                                                            </div>
                                                        </div>

                                                    </form>
                                                ) : (
                                                    <div className="text-center py-4">
                                                        <p className="text-muted small">Select a template to modify</p>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {showAllowUploadPopup && (
                                <Modal show onHide={handleCancelUpload} backdrop="static" keyboard={false} style={{ marginTop: '12vh' }}>
                                    <Modal.Header style={{ backgroundColor: '#366872', color: 'white', padding: '0.5rem 1rem' }}>
                                        <Modal.Title style={{ fontSize: '16px' }}>Confirmation</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body style={{ padding: '0.75rem 1rem', fontSize: '14px' }}
                                        /* <sttong>{toTitleCase(editableTableName)}</sttong> Template is already exists. Do you wish to upload data with the same template? */
                                        dangerouslySetInnerHTML={{
                                            __html: modalMessage3.replace(/\n/g, '<br />')
                                        }}>
                                    </Modal.Body>
                                    <Modal.Footer style={{ borderTop: 'none' }}>
                                        <Button variant="secondary" onClick={handleCancelUpload}>No</Button>
                                        <Button variant="primary" onClick={handleForceUpload}>Yes</Button>
                                    </Modal.Footer>
                                </Modal>
                            )}

                            {/* Modal for messages */}
                            <Modal
                                show={!!modalMessage}
                                onHide={handleCloseModal}
                                backdrop="static"
                                keyboard={false}
                                style={{ marginTop: '12vh' }}
                            >
                                <div
                                    className={`alert alert-${messageType === 'success' ? 'success' : messageType === 'warning' ? 'warning' : 'danger'} alert-dismissible fade show`}
                                    role="alert"
                                    style={{ marginBottom: '0' }}
                                >
                                    <div className="d-flex align-items-center">
                                        {messageType === 'success' ? (
                                            <span className="me-2" style={{ color: 'green', fontSize: '14px' }}>✅</span>
                                        ) : messageType === 'warning' ? (
                                            <span className="me-2" style={{ color: '#ffc107', fontSize: '14px' }}>⚠️</span>
                                        ) : (
                                            <span className="me-2" style={{ color: 'red', fontSize: '14px' }}>❌</span>
                                        )}
                                        <p
                                            style={{
                                                display: 'inline',
                                                marginBottom: '0px',
                                                color: messageType === 'success'
                                                    ? 'green'
                                                    : messageType === 'warning'
                                                        ? '#ffc107'
                                                        : 'red'
                                            }}
                                        >
                                            {modalMessage}
                                        </p>
                                    </div>
                                    <button
                                        type="button"
                                        className="btn-close"
                                        onClick={handleCloseLdap}
                                        style={{ width: '15px', height: '15px', fontSize: '8px', position: 'absolute', bottom: '10px', right: '10px' }}
                                    />
                                </div>
                            </Modal>
                        </div>
                    </div>
                </div>
            </main>
            <Footer />
        </div>
    );
};

export default GapsyComplaintsConfiguration;
